<template>
  <div :class="['half-screen', 'docInteract', 'history-action']">
    <div>
      <div class="panel-header flex-row  flex__between has-border__bottom">
        <p class="title font-weight__bold">Lịch sử</p>
        <div class="btn__action">
          <i class="fal fa-expand item clickable" v-show="expandable"></i>
          <i
            v-show="closable"
            class="fal fa-times item clickable"
            @click="$emit('closeHistory')"
          ></i>
        </div>
      </div>

      <VuePerfectScrollbar
        class="scroll-history"
        :settings="perfectScrollbarSetting"
      >
        <div :class="['panel-body', 'list__action']">
          <slot name="histories"></slot>
        </div>
      </VuePerfectScrollbar>

      <div id="detail-footer" class="panel-footer">
        <slot name="footer"></slot>
      </div>

    </div>
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "history-template",
  mixins: [handleRequestErrorMixin],
  props: ["expandable", "closable"],
  components: {VuePerfectScrollbar},
  filters: {},

  data() {
    return {
      isFullScreen: true,
      histories: []
    };
  },

  watch: {},
  computed: {},

  created() {
  },

  methods: {}
};
</script>

<style scoped>
.full-screen {
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 100%;
}

.half-screen {
  width: 75%;
  max-width: 420px;
  transition: 0.5s;
}

@keyframes half-to-full {
  from {
    width: 75%;
  }
  to {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/history-template.vue